import React from 'react';
import PropTypes from 'prop-types';
import { lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';

// Form options constants
const bqOptions = lookupsJson.farm.buildingQuality;
const occupancyUseTypeByStructureCategory = lookupsJson.farm.occupancyUseTypeByStructureCategory;

const SilosGrainBinsFields = ({
  fieldName,
  buildingType,
  initialBuilding,
  disableRiskForm,
  shouldEnableDiameterHeight,
  shouldEnableSqFt,
  toastRCEWarning,
  ctOptions
}) => {
  return (
    <>
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.occupancy`}
        name={`${fieldName}.building.occupancy`}
        mode="light"
        label="Occupancy or use type"
        options={occupancyUseTypeByStructureCategory[buildingType]}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.occupancy) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="numeric"
        id={`${fieldName}.building.yearBuilt`}
        name={`${fieldName}.building.yearBuilt`}
        mode="light"
        label="Year built in"
        format={{
          allowNegative: false
        }}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.yearBuilt) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${fieldName}.building.diameter`}
        name={`${fieldName}.building.diameter`}
        mode="light"
        label="Diameter (ft)"
        disabled={disableRiskForm || !shouldEnableDiameterHeight}
        onChange={(val) => {
          if (val !== initialBuilding?.diameter) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${fieldName}.building.height`}
        name={`${fieldName}.building.height`}
        mode="light"
        label="Height (ft)"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.height) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={4}
        type="numeric"
        id={`${fieldName}.building.sqFt`}
        name={`${fieldName}.building.sqFt`}
        mode="light"
        label="Total sqft"
        disabled={disableRiskForm || !shouldEnableSqFt}
        onChange={(val) => {
          if (val !== initialBuilding?.sqFt) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.buildingQuality`}
        name={`${fieldName}.building.buildingQuality`}
        mode="light"
        label="Quality"
        options={bqOptions}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.buildingQuality) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.constructionType`}
        name={`${fieldName}.building.constructionType`}
        mode="light"
        label="Construction type"
        options={ctOptions}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.constructionType) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="numeric"
        id={`${fieldName}.building.bushelCapacity`}
        name={`${fieldName}.building.bushelCapacity`}
        mode="light"
        label="Bushel capacity"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.bushelCapacity) {
            toastRCEWarning();
          }
        }}
      />
    </>
  );
};

SilosGrainBinsFields.propTypes = {
  fieldName: PropTypes.string.isRequired,
  buildingType: PropTypes.string.isRequired,
  initialBuilding: PropTypes.object.isRequired,
  disableRiskForm: PropTypes.bool.isRequired,
  shouldEnableDiameterHeight: PropTypes.bool.isRequired,
  shouldEnableSqFt: PropTypes.bool.isRequired,
  toastRCEWarning: PropTypes.func.isRequired,
  ctOptions: PropTypes.array.isRequired
};

export default SilosGrainBinsFields;
